const ecommerceConfig = {
  businessName: "ShopNest",
  productsLabel: "Shop",
  tagline: "Shop Smart. Live Better.",
  description:
    "ShopNest is your one-stop online store for premium electronics, fashion, home décor, and lifestyle products — delivered fast across India.",
  mission: "To make quality products accessible to every household in India with a seamless, trustworthy shopping experience.",
  vision: "To become India's most loved D2C brand known for quality, affordability, and customer delight.",
  logo: null,
  favicon: null,
  theme: {
    primaryColor: "#f97316",
    secondaryColor: "#ea580c",
    accentColor: "#fed7aa",
    backgroundColor: "#ffffff",
    textColor: "#1c1917",
    darkBackground: "#1c1917",
    darkText: "#f5f5f4",
    borderRadius: "12px",
    fontFamily: "'Inter', sans-serif",
  },
  darkModeEnabled: true,
  defaultDarkMode: false,
  seo: {
    title: "ShopNest | Premium Online Store",
    description: "Shop electronics, fashion, home décor and more at ShopNest. Best prices, fast delivery, easy returns.",
    keywords: "online shopping, ecommerce, electronics, fashion, home decor, ShopNest",
    ogImage: "https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=1200&q=80",
    twitterCard: "summary_large_image",
  },
  contact: {
    phone: "+91 98200 77777",
    whatsapp: "919820077777",
    email: "support@shopnest.in",
    website: "www.shopnest.in",
    address: "ShopNest Warehouse, Andheri East, Mumbai - 400069, India",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241317.11609823277!2d72.74109995709657!3d19.08250589563531!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c6306644edc1%3A0x5da4ed8f8d648c69!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1718000000000",
  },
  businessHours: [
    { day: "Monday – Saturday", hours: "9:00 AM – 8:00 PM" },
    { day: "Sunday", hours: "10:00 AM – 6:00 PM" },
  ],
  social: {
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
    linkedin: "https://linkedin.com",
    youtube: "https://youtube.com",
    twitter: "https://twitter.com",
  },
  hero: {
    heading: "Premium Products, Delivered to Your Door",
    subheading: "Discover thousands of curated products across electronics, fashion, home & lifestyle — with fast delivery and easy returns.",
    ctaPrimary: { label: "Shop Now", link: "/ecommerce/products" },
    ctaSecondary: { label: "View Categories", link: "/ecommerce/services" },
    images: [
      "https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=1400&q=80",
      "https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=1400&q=80",
      "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1400&q=80",
    ],
  },
  about: {
    heading: "About ShopNest",
    subheading: "Trusted by 50,000+ Happy Customers",
    body: "Founded in 2018, ShopNest has grown into one of India's fastest-growing D2C platforms. We source directly from manufacturers and verified sellers to bring you the best quality at the best prices. With 50,000+ happy customers and a 4.8-star average rating, we're committed to making your shopping experience delightful.",
    highlights: ["50,000+ Happy Customers", "10,000+ Products Listed", "Same-Day Delivery in Mumbai", "Easy 7-Day Returns"],
    image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&q=80",
  },
  services: [
    { id: 1, icon: "FaMobileAlt",    title: "Electronics",    description: "Smartphones, laptops, earbuds, smartwatches and the latest gadgets at unbeatable prices.", image: "" },
    { id: 2, icon: "FaCut",          title: "Fashion",        description: "Trendy clothing, footwear, and accessories for men, women, and kids.", image: "" },
    { id: 3, icon: "FaHome",         title: "Home & Décor",   description: "Furniture, lighting, kitchenware, and décor to transform your living space.", image: "" },
    { id: 4, icon: "FaLeaf",         title: "Health & Beauty", description: "Skincare, wellness supplements, fitness gear, and personal care essentials.", image: "" },
    { id: 5, icon: "FaCamera",       title: "Photography",    description: "Cameras, lenses, tripods, and accessories for hobbyists and professionals.", image: "" },
    { id: 6, icon: "FaDumbbell",     title: "Sports & Fitness", description: "Gym equipment, sportswear, yoga mats, and outdoor adventure gear.", image: "" },
  ],
  // ── PRODUCTS (ecommerce-only field) ──────────────────────
  products: [
    {
      id: 1,
      name: "Sony WH-1000XM5 Headphones",
      category: "Electronics",
      price: 29990,
      originalPrice: 34990,
      image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=600&q=80",
      description: "Industry-leading noise cancellation, 30-hour battery, premium sound quality.",
      badge: "Best Seller",
      inStock: true,
    },
    {
      id: 2,
      name: "Apple Watch Series 9",
      category: "Electronics",
      price: 41900,
      originalPrice: 44900,
      image: "https://images.unsplash.com/photo-1546868871-7041f2a55e12?w=600&q=80",
      description: "Advanced health tracking, crash detection, always-on retina display.",
      badge: "New",
      inStock: true,
    },
    {
      id: 3,
      name: "Men's Slim Fit Blazer",
      category: "Fashion",
      price: 2499,
      originalPrice: 4999,
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&q=80",
      description: "Premium wool-blend fabric, tailored fit, available in Navy, Black, and Grey.",
      badge: "50% Off",
      inStock: true,
    },
    {
      id: 4,
      name: "Minimalist Desk Lamp",
      category: "Home & Décor",
      price: 1899,
      originalPrice: 2999,
      image: "https://images.unsplash.com/photo-1507473885765-e6ed057f782c?w=600&q=80",
      description: "Touch-dimmer, USB charging port, 3 color temperatures, sleek aluminum body.",
      badge: "Trending",
      inStock: true,
    },
    {
      id: 5,
      name: "Canon EOS M50 Mark II",
      category: "Photography",
      price: 54990,
      originalPrice: 59990,
      image: "https://images.unsplash.com/photo-1516035069371-29a1b244cc32?w=600&q=80",
      description: "24.1MP APS-C sensor, 4K video, Dual Pixel CMOS AF, ideal for creators.",
      badge: null,
      inStock: true,
    },
    {
      id: 6,
      name: "Yoga Mat Pro (6mm)",
      category: "Sports & Fitness",
      price: 999,
      originalPrice: 1799,
      image: "https://images.unsplash.com/photo-1601925228008-f5e4c5e5e5e5?w=600&q=80",
      description: "Non-slip surface, eco-friendly TPE material, includes carry strap.",
      badge: "Hot Deal",
      inStock: true,
    },
    {
      id: 7,
      name: "Vitamin C Serum 30ml",
      category: "Health & Beauty",
      price: 699,
      originalPrice: 1299,
      image: "https://images.unsplash.com/photo-1556228578-8c89e6adf883?w=600&q=80",
      description: "20% Vitamin C + Hyaluronic Acid, brightens skin, reduces dark spots.",
      badge: "Popular",
      inStock: true,
    },
    {
      id: 8,
      name: "Mechanical Keyboard TKL",
      category: "Electronics",
      price: 4499,
      originalPrice: 6999,
      image: "https://images.unsplash.com/photo-1587829741301-dc798b83add3?w=600&q=80",
      description: "RGB backlit, Cherry MX switches, tenkeyless compact design.",
      badge: null,
      inStock: false,
    },
  ],
  stats: [
    { value: 50000, label: "Happy Customers", suffix: "+" },
    { value: 10000, label: "Products Listed", suffix: "+" },
    { value: 48,    label: "Hour Delivery",   suffix: "hr" },
    { value: 4.8,   label: "Average Rating",  suffix: "★" },
  ],
  whyUs: {
    heading: "Why Shop with ShopNest?",
    subheading: "Your satisfaction is our priority",
    points: [
      { icon: "FaShieldAlt",    title: "100% Authentic",     description: "Every product is sourced from verified sellers and comes with authenticity guarantee." },
      { icon: "FaClock",        title: "Fast Delivery",      description: "Same-day delivery in Mumbai, 48-hour delivery across India." },
      { icon: "FaHandsHelping", title: "Easy Returns",       description: "Hassle-free 7-day return policy. No questions asked." },
      { icon: "FaChartLine",    title: "Best Prices",        description: "We match or beat any competitor price. Shop with confidence." },
    ],
  },
  gallery: [
    { id: 1, src: "https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=800&q=80", alt: "Store Front",      category: "Store" },
    { id: 2, src: "https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=800&q=80", alt: "Shopping",         category: "Store" },
    { id: 3, src: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&q=80", alt: "Products Display", category: "Products" },
    { id: 4, src: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=800&q=80", alt: "Electronics",      category: "Products" },
    { id: 5, src: "https://images.unsplash.com/photo-1546868871-7041f2a55e12?w=800&q=80", alt: "Wearables",          category: "Products" },
    { id: 6, src: "https://images.unsplash.com/photo-1587829741301-dc798b83add3?w=800&q=80", alt: "Accessories",      category: "Products" },
  ],
  pricing: [
    {
      id: 1, name: "Basic", price: "Free", period: "forever",
      features: ["Browse All Products", "WhatsApp Orders", "Email Support", "Order Tracking"],
      highlighted: false,
    },
    {
      id: 2, name: "ShopNest Plus", price: "₹199", period: "per month",
      features: ["Free Delivery on All Orders", "Early Access to Sales", "Priority Support", "Exclusive Member Discounts", "Easy Returns Extended to 15 Days"],
      highlighted: true,
    },
    {
      id: 3, name: "Business", price: "₹999", period: "per month",
      features: ["Bulk Order Discounts", "Dedicated Account Manager", "Custom Invoicing", "API Access", "White-label Options"],
      highlighted: false,
    },
  ],
  testimonials: [
    { id: 1, name: "Sneha Patil",   role: "Mumbai",    review: "Ordered the Sony headphones and they arrived the same day! Packaging was perfect and the product is exactly as described. Love ShopNest!", rating: 5, avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&q=80" },
    { id: 2, name: "Rohit Sharma",  role: "Pune",      review: "Best prices I've found online. The WhatsApp ordering is super convenient — I just sent a message and my order was confirmed in minutes.", rating: 5, avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&q=80" },
    { id: 3, name: "Kavya Menon",   role: "Bangalore", review: "Returned a product effortlessly. The 7-day return policy is genuine and the refund was processed within 2 days. Highly trustworthy!", rating: 5, avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&q=80" },
  ],
  team: [],
  faq: [
    { id: 1, question: "How do I place an order via WhatsApp?",    answer: "Click the 'Buy Now' button on any product. It will open WhatsApp with the product details pre-filled. Just send the message and our team will confirm your order within minutes." },
    { id: 2, question: "What is your delivery timeline?",          answer: "Same-day delivery in Mumbai for orders placed before 2 PM. Pan-India delivery within 48 hours. Remote areas may take 3-5 business days." },
    { id: 3, question: "What is your return policy?",              answer: "We offer a hassle-free 7-day return policy. ShopNest Plus members get 15 days. Just WhatsApp us with your order ID and reason." },
    { id: 4, question: "Are the products genuine?",                answer: "Yes, 100%. We source directly from authorized distributors and verified sellers. All electronics come with official brand warranty." },
    { id: 5, question: "Do you offer Cash on Delivery?",           answer: "Yes! COD is available for orders up to ₹10,000. For higher amounts, we accept UPI, cards, and net banking." },
  ],
  cta: {
    heading: "Ready to Start Shopping?",
    subheading: "Browse 10,000+ products and order instantly via WhatsApp. Fast delivery, easy returns.",
    buttonLabel: "Shop Now",
    buttonLink: "/ecommerce/products",
  },
  footer: {
    tagline: "Shop Smart. Live Better.",
    copyright: `© ${new Date().getFullYear()} ShopNest. All Rights Reserved.`,
    links: [
      { label: "Home",     path: "/ecommerce" },
      { label: "Products", path: "/ecommerce/products" },
      { label: "Gallery",  path: "/ecommerce/gallery" },
      { label: "Contact",  path: "/ecommerce/contact" },
    ],
  },
  sections: {
    hero: true, about: true, services: true, whyUs: true,
    stats: true, gallery: true, pricing: true, testimonials: true,
    team: false, faq: true, cta: true, contact: true,
    products: true,
    enquireMode: false,   // false = Buy Now, true = Enquire for all products   // ← ecommerce-only flag
  },
};

export default ecommerceConfig;
